/**
 * FleetManager V3 - Card Component
 */

import React from 'react';

export function Card({
  children,
  className = '',
  padding = 'p-3',
  hover = false,
  onClick
}) {
  return (
    <div
      className={`
        bg-white dark:bg-slate-800/50 border border-gray-200 dark:border-slate-700/50 rounded-xl shadow-sm
        ${padding}
        ${hover ? 'hover:bg-gray-50 dark:hover:bg-slate-800/70 cursor-pointer transition-colors' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '' }) {
  return (
    <div className={`flex items-center justify-between mb-2 ${className}`}>
      {children}
    </div>
  );
}

export function CardTitle({ icon: Icon, children, iconColor = 'text-blue-500 dark:text-blue-400' }) {
  return (
    <span className="font-semibold text-gray-900 dark:text-white text-sm flex items-center gap-1.5">
      {Icon && <Icon size={14} className={iconColor} />}
      {children}
    </span>
  );
}

export function CardContent({ children, className = '' }) {
  return (
    <div className={className}>
      {children}
    </div>
  );
}

export default Card;
